import { ReactElement } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

export function SkeletonItem(): ReactElement {
  return (
    <div className={styles.block}>
      <Skeleton variant='square' />
      <div className={styles.textContainer}>
        <Skeleton variant='line' height={12} style={{ maxWidth: '60%' }} />
        <Skeleton
          variant='line'
          margin={{ top: 16 }}
          style={{ maxWidth: '85%' }}
        />
        <Skeleton
          variant='line'
          margin={{ top: 8, right: 16 }}
          style={{ maxWidth: '75%' }}
        />
      </div>
    </div>
  );
}
